import { router, useGlobalSearchParams, usePathname } from 'expo-router'
import { useCallback, useEffect, useState } from 'react'
import { useIntroStore } from './useIntroStore'
import { useStaff } from './useSession'

const addParam = (url: string | undefined, key: string, value: string) => {
  if (!url) return url
  const [pathname, search = ''] = url.split('?')
  const params = new URLSearchParams(search)
  params.set(key, value)

  return `${pathname}?${params.toString()}`
}

const setInitialValue = (value?: boolean) => {
  if (value === undefined) return undefined
  router.setParams({ past_deals: value ? '1' : undefined })
}

export const usePastDeals = (initial?: boolean) => {
  const staff = useStaff()

  const [isInitialSet, setIsInitialSet] = useState(initial === undefined)

  const { past_deals } = useGlobalSearchParams<{ past_deals?: string }>()

  const { toggleMode } = useIntroStore()

  const showPastDeals = !isInitialSet ? !!initial : past_deals === '1'

  const pathname = usePathname()

  const togglePastDeals = useCallback(() => {
    setInitialValue(!showPastDeals)
  }, [showPastDeals])

  useEffect(() => {
    if (isInitialSet) return
    setIsInitialSet(true)
    setInitialValue(initial)
  }, [initial, isInitialSet])

  const toggle = useCallback(
    ({ redirect }: { redirect?: string }) => {
      const isCurrentRoute = !redirect || pathname === redirect
      if (staff && isCurrentRoute) {
        togglePastDeals()
        return
      }
      const url = addParam(redirect, 'past_deals', '1')

      if (staff && url) {
        router.navigate(url)
        return
      }

      toggleMode('staff', {
        redirect: url,
      })
    },
    [staff, toggleMode, togglePastDeals, pathname]
  )

  return {
    value: showPastDeals && !!staff,
    toggle,
  }
}
